import { render } from "./new-notification-client.vue?vue&type=template&id=d6be8d10"
import script from "./new-notification-client.vue?vue&type=script&lang=js"
export * from "./new-notification-client.vue?vue&type=script&lang=js"

import "./new-notification-client.vue?vue&type=style&index=0&id=d6be8d10&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__